const manifest = document.getElementById('ThemeComponentModules');
const pending = new Map(JSON.parse(manifest?.textContent || '[]').map((entry) => [entry.url, entry.selector]));

function loadComponents(roots) {
  for (const [url, selector] of pending) {
    if (!roots.some((root) => root.matches?.(selector) || root.querySelector?.(selector))) continue;
    pending.delete(url);
    import(url).catch((error) => {
      pending.set(url, selector);
      console.error('[theme-components] Module failed to load:', url, error);
    });
  }
}

loadComponents([document]);
new MutationObserver((mutations) => {
  const roots = mutations.flatMap((mutation) => [...mutation.addedNodes]).filter((node) => node instanceof Element);
  if (roots.length && pending.size) loadComponents(roots);
}).observe(document.body, { childList: true, subtree: true });
document.addEventListener('shopify:section:load', (event) => loadComponents([event.target]));
